import 'babel-polyfill';
import React from 'react';
import {render} from 'react-dom';
import App from 'app';
import Customisation from 'app/customisations/phg';

const CustomizedApp = App(
    Customisation,
    window.Config.network,
    window.Config.captchaSiteKey,
    window.Config.isAvailable,
    window.Config.captchaProvider
);
render(<CustomizedApp />, document.getElementById('app'));
